module.exports = __webpack_public_path__ + "img/57ne.39a95053.svg";